export const companyData = {
    name: 'Adsversa',
    tagline: 'Complete Digital Marketing & Technical Solutions || Grow Your Business Globally',
    description: 'We provide comprehensive digital marketing services and technical solutions including website development, migrations, SEO, social media marketing, and advertising campaigns worldwide.',
    contact: {
        email: {
            primary: 'info@adsversa.com'
        },
        phone: {
            number: '+91 7078785103',
            hours: '24/7 Support'
        },
        address: {
            street: '12th floor, Galaxy Blue Sapphire Plaza',
            city: 'Greater Noida, Uttar Pradesh 201318'
        }
    }
};
